import mitt from "mitt";

type Events = Record<string, unknown>;

export default defineNuxtPlugin(() => {
  const emitter = mitt<Events>();

  return {
    provide: {
      eventBus: {
        $on: emitter.on,
        $off: emitter.off,
        $emit: emitter.emit,
      },
    },
  };
});
